<template>
  <div class="overflow-x-hidden">
  <Nav />
  <router-view />
  <Footer />
</div>
</template>

<script>
import Footer from "@/components/base/Footer.vue";
import Nav from "@/components/nav/Nav.vue";

export default {
  components: { Nav, Footer },
};
</script>
